// productHelper.js

/**
 * estructura ResumenData
 * por default solo retorna los items agregados al carrito (item con propiedad 'actual' en false)
 * 
 * @param array ResumenData 
 * @param bool allItems - 'false' por default - 'true' si se requieren todos los items
 * @returns 
 */
export const transformProducts = (ResumenData, allItems = false) => {
    let products = ResumenData.filter(item => item.actual === false || allItems).flatMap(item => {
      let regperiod = '';
      let billingcycle = '';
      let privacy_protection = '';
  
      if (item.type === 'domain') {
        regperiod = String(item.periodo).replace(/año/gi, "").replace(/\(s\)/gi, "").trim();
        privacy_protection = item.product.privacy_protection;
      } else {
        billingcycle = getBillingCycle(item.periodo);
      }
  
      return item.product.domain_section.map(domain => {
        let productData = {};
  
        if (domain.dominio_principal !== '') {
          productData.domain = domain.dominio_principal;
        }
  
        if (domain.domain_type !== '') {
          productData.domaintype = domain.domain_type;
        }
  
        if (regperiod !== '') {
          productData.regperiod = regperiod;
        }
  
        if (item.product.id !== '') {
          productData.product_id = item.product.id;
        }
  
        if (billingcycle !== '') {
          productData.billingcycle = billingcycle;
        }
  
        if (privacy_protection !== '') {
          productData.privacy_protection = privacy_protection;
        }

        // Agregar configuración de sistema operativo si es VPS
        if (item.type === "vps" && !item.product.isOX && !item.product.isWP) {
          const selectedSO = domain.so; // SO seleccionado
          if (selectedSO) {
            const matchingSO = item.sos.find(so => so.sosName === selectedSO);
            if (matchingSO) {
              productData.configoptions = { [matchingSO.idconf]: matchingSO.idso };
            }
          }
        }
  
        return Object.keys(productData).length > 0 ? productData : null;
      }).filter(item => item !== null);
    });
  
    // Step 1: Create a map to store regperiod values by domain
    const regPeriodMap = products.reduce((map, item) => {
      if (item.regperiod && item.domain) {
        map[item.domain] = item.regperiod;
      }
      return map;
    }, {});
  
    // Step 2: Create a map to store privacy_protection
    const privacyProtMap = products.reduce((map, item) => {
      if (item.privacy_protection && item.domain) {
        map[item.domain] = item.privacy_protection;
      }
      return map;
    }, {});


    // step 3: obtenemos solo los dominios con producto relacionado
    const domainsProduct = products.reduce((map, item) => {
      if(item.domain && item.product_id){
        map[item.domain] = item.product_id;
      }
      return map;
    }, {});
  
    // Step 4: Merge regperiod into objects and filter out objects with only regperiod
    const mergedData = products.reduce((result, item) => {
      if (item.regperiod) {
        // si el dominio agregado no le pertenece a un producto
        if(! domainsProduct[item.domain]){
          result.push(item);
        }

        return result; // Skip objects with only regperiod
      }
      
      if (item.domain && regPeriodMap[item.domain]) {
        item.regperiod = regPeriodMap[item.domain];
      }

      if (item.domain && privacyProtMap[item.domain]) {
        item.privacy_protection = privacyProtMap[item.domain];
      }

      result.push(item); // Push objects
      
      return result;
    }, []);
  
    return mergedData; // Retorna los datos transformados
  };

  function getBillingCycle(period) {
    switch (period.toLowerCase()) {
        case "1 mes":
            return "monthly";
        case "3 meses":
            return "quarterly";
        case "6 meses":
            return "semiannually";
        case "12 meses":
            return "annually";
        case "24 meses":
            return "biennially";
        case "36 meses":
            return "triennially";
        default:
            return "unknown period";
    }
}
  